import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanCandidate} from "@/store/clan/types";
import {Keys} from "@/constants/key";
import Container = Phaser.GameObjects.Container;
import ClanUtils from "@/utils/clan-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";

export class ClanCandidatePanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 600;

    private cont: Container | undefined;
    private cc!: ClanCandidate;

    constructor(scene: Phaser.Scene, c: ClanCandidate, callback: (cc: ClanCandidate) => unknown) {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, ClanCandidatePanel.HEIGHT);

        this.add(back);

        let settings = SpriteUtils.addSprite(this.scene, 550, 42, Keys.CLAN_GEAR);
        settings.setInteractive().on('pointerup', () => {
            callback(this.cc);
        });
        this.add(settings);

        this.init(scene, c);
    }

    public init(scene: Phaser.Scene, cc: ClanCandidate) {
        this.cc = cc;
        if (this.cont) {
            this.cont.setVisible(false);
            this.cont.destroy();
        }
        this.cont = new Container(scene);

        let status = SpriteUtils.addSprite(this.scene, 36, 40, cc.online ? Keys.CLAN_ONLINE : Keys.CLAN_OFFLINE);
        let titleText = TextUtils.addTextAdvanced(scene, cc.name, 65, 20,
            '#eec761', 18, 'normal', 480, 'left', 2, Fonts.BENGALY_NORMAL);

        let descText = TextUtils.addTextAdvanced(scene, ClanUtils.getStatus(cc.state) + Tr('comma.lev') + cc.level, titleText.x / CU.S, titleText.y / CU.S + 20,
            '#a8a8a8', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let onlineText = TextUtils.addTextAdvanced(scene,  Tr('luchshaja.pobeda.ur') + cc.bestVictoryStair + ', ' + cc.lastActivityAt, titleText.x / CU.S, descText.y / CU.S + 20,
            '#6c6c6c', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        onlineText.setStroke('#000000', 1);

        let sep = SpriteUtils.addSprite(this.scene, 300, onlineText.y / CU.S + 18, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        this.height = sep.y / CU.S + 1;

        this.cont.add([status, titleText, descText, onlineText, sep]);
        this.add(this.cont);
    }

}
